module.exports = __webpack_public_path__ + "img/ico-telephone-brand-color.85463fbf.svg";